"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUnixTimestampToDate = transformUnixTimestampToDate;
function transformUnixTimestampToDate(timestamp) {
    return new Date(timestamp * 1000);
}
//# sourceMappingURL=transformUnixTimestampToDate.js.map